import { LocationTranslate } from './locationTranslate.model';

const locationTranslatePTBR: LocationTranslate = {
  combobox: {
    triggerAriaLabel: 'Selecionar local',
    placeholder: 'Local',
    searchPlaceholder: 'Buscar local...',
    loading: 'Carregando locais...',
    empty: 'Nenhum local encontrado',
    clear: 'Remover local',
    createNew: 'Cadastrar novo local',
    createNamed: 'Cadastrar "{{name}}"',
    createTitle: 'Novo local',
    editTitle: 'Editar local',
    editAriaLabel: 'Editar local {{name}}',
    namePlaceholder: 'Nome do local',
    addressToggle: 'Endereço (opcional)',
    cancel: 'Cancelar',
    confirm: 'Cadastrar',
    save: 'Salvar',
    delete: 'Excluir',
    confirmDelete: 'Confirmar exclusão',
  },
  toast: {
    created: 'Local cadastrado com sucesso',
    updated: 'Local atualizado com sucesso',
    deleted: 'Local excluído com sucesso',
    error: {
      create: 'Não foi possível cadastrar o local',
      update: 'Não foi possível atualizar o local',
      delete: 'Não foi possível excluir o local',
    },
  },
};

export default locationTranslatePTBR;
